import { useEffect, useState } from 'react'

const DEFAULT_MOBILE_BREAKPOINT = 991

const getIsMobile = (breakpoint) => {
  if (typeof window === 'undefined') {
    return false
  }

  return window.innerWidth <= breakpoint
}

function useIsMobile(breakpoint = DEFAULT_MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(() => getIsMobile(breakpoint))

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile(breakpoint))
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [breakpoint])

  return isMobile
}

export default useIsMobile
